
  import * as ipxRuntime$vaKhIjKUeDyL5Oq1lO64FHCDNxixAHXG5vlUGAZDUS0 from '/www/wwwroot/FTS/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "webp"
  ],
  "quality": 65
},
    providers: {
        ['ipx']: { provider: ipxRuntime$vaKhIjKUeDyL5Oq1lO64FHCDNxixAHXG5vlUGAZDUS0, defaults: {} }
    }
  }
